document.addEventListener('DOMContentLoaded', (e) => {
	if (document.getElementsByTagName('body')[0].classList.contains('p-topic')) {
		const resourcesDrawer = document.querySelector(
			'.m-topics__resources__drawer'
		);
		const resourcesButton = document.querySelector('.a-topics__view_more');
		if (resourcesButton !== null) {
			resourcesButton.addEventListener('click', function (e) {
				e.preventDefault();
				resourcesDrawer.classList.toggle('open');

				if (resourcesDrawer.classList.contains('open')) {
					resourcesDrawer.style.height = resourcesDrawer.scrollHeight + 'px';
					resourcesButton.textContent = 'View Fewer';
				} else {
					resourcesDrawer.setAttribute('style', '');
					resourcesButton.textContent = 'View All';
				}
			});
		}
	}
});
